import { useLocation, useNavigate } from "react-router-dom";
import PdfViewer from "../../../components/PDFViewer/PDFViewer";
import { ReactComponent as BackIcon } from "../../../images/back.svg";
import { Button } from "antd";
import { downloadFlooringDocumentsUnzip, handleDownload } from "../../../common/Utilities";
import { FlooringCaseSummaryUrl } from "../../../common/Constants";

function CaseSummary() {
  const navigate = useNavigate();
  const location = useLocation();
  const AppId = location.state?.appId
  const AgentId = location.state?.AgentId
  console.log("LOCATION", location.state);
  const pdfUrl = "https://www.africau.edu/images/default/sample.pdf";
  return (
    <section className="common_container">
      <header className="common-header flex justify-between flex-wrap gap-4">
        <div className="common-header-body">
          <h1 className=" flex items-center gap-3 flex-wrap">
            <span
              className="cursor-pointer"
              onClick={() => {
                navigate("/flooring-cases/view", {
                  state: location.state,
                });
              }}
            >
              <BackIcon />
            </span>
            Case Summary
          </h1>
        </div>
      </header>
      <section>
        <PdfViewer
          AppId={AppId}
          AgentId={""}
          title="Case Summary"
          type="CASE"
        />      </section>
      <footer className="footer-pdf-btn-block">
        <Button type="submit" className="sav_btn"
          onClick={() => {
            downloadFlooringDocumentsUnzip("Flooring-Application-Summary", AppId, "All");
          }}
        >
          Download All Relevant Documents
        </Button>
        <Button type="submit" className="sav_btn"
          onClick={() => {
            handleDownload(
              `${FlooringCaseSummaryUrl}${AppId}/${AgentId}`
            );
          }}
        >
          Download Summary Only
        </Button>
      </footer>
    </section>
  );
}

export default CaseSummary;
